/* eslint-disable */
import * as loginActions from '../../actions/login-actions/loginActions';
import { Auth } from 'aws-amplify';
import { history } from '../../history';
import axios from 'axios';
var jwtDecode = require('jwt-decode');
const THOUSAND = 1000;
const SIXTYMILLI = 3600;

const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';

let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';
let API_KEY = process.env.REACT_APP_RTCP_API_KEY;

export function verifyUserSignup(user, onSuccess) {
  console.log('resetPassword', user);

  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(loginActions.setAgentRemoveInfoError());
    // dispatch(loginActions.setLoginPending(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/verify-user-signup`, '', {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
          emailId: user,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log('resetPasswordVerifyUser response', response);
        if (!response.data) {
          let data = {
            resend: true,
            email: user,
            error: `Your account isn't confirmed! 
                Please check your email to find the confirmation code.`,
          };
          history.push('/register', { data });
        } else {
          onSuccess();
        }
        // dispatch(loginActions.setLoginError(false, error.message));
      })
      .catch(error => {
        dispatch(
          loginActions.setLoginError(false, 'Incorrect username or password.'),
        );
        //localStorage.clear();
        // history.push('/login');
      });
  };
}

export function disableUserSignIn(user) {
  console.log('disableUserSignIn', user);

  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(loginActions.setAgentRemoveInfoError());
    dispatch(loginActions.setLoginPending(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/disable-user-signin`, '', {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
          emailId: user,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log('resetPasswordVerifyUser response', response);
        dispatch(loginActions.setLoginDisable(false, response.data));
        history.push('/login');
      })
      .catch(error => {
        dispatch(
          loginActions.setLoginError(false, error.response.data.message),
        );
        localStorage.clear();
        history.push('/login');
      });
  };
}

export function login(user, pass, onSuccess) {
  const username = user;
  const password = pass;

  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(loginActions.setAgentRemoveInfoError());
    dispatch(loginActions.setLoginPending(true));
    Auth.signIn(username, password)
      .then(response => {
        Auth.userSession(response)
          .then(session => {
            console.log(
              'actions.validateUserSession():Auth.userSession() session:',
              session.idToken.jwtToken,
            );
            // finally invoke isValid() method on session to check if auth tokens are valid
            // if tokens have expired, lets call "logout"
            // otherwise, dispatch AUTH_USER success action and by-pass login screen
            if (session.isValid()) {
              dispatch(
                loginActions.setLoginSuccess(
                  false,
                  response,
                  getCurrentUser(response.attributes),
                  response.signInUserSession.idToken.jwtToken,
                ),
              );
              //     setTimeout(() => {
              axios
                .post(
                  `${API_ENDPOINT}/v1/surety-bond/agent/check`,
                  getCurrentUser(response.attributes),
                  {
                    headers: {
                      'Content-Type': 'application/json',
                      //  'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Headers': authHeader,
                      'Access-Control-Allow-Methods': '*',
                      'Access-Control-Allow-Credentials': 'true',
                      Authorization:
                        `Bearer ` + response.signInUserSession.idToken.jwtToken,
                    },
                    crossorigin: true,
                  },
                )
                .then(response => {
                  console.log('Add User Response', response);
                })
                .catch(error => {
                  if (error) {
                    localStorage.clear();
                    history.push('/logout');
                  }
                  if (error.response.status === 503) {
                    dispatch(
                      loginActions.setLoginError(
                        false,
                        `Service is temporarily down. Please try again later.
                         If the problem persists contact Customer Service at 1-800-226-3545  ERR:NCP-APIGEE-SERV-DOWN`,
                      ),
                    );
                  } else if (error.response.status === 409) {
                    dispatch(
                      loginActions.setLoginError(
                        false,
                        `Service is temporarily down. Please try again later. 
                        If the problem persists contact Customer Service at 1-800-226-3545 ERR:NCP-DB-DOWN`,
                      ),
                    );
                  } else {
                    dispatch(
                      loginActions.setLoginError(
                        false,
                        `Service is temporarily down. Please try again later. 
                        If the problem persists contact Customer Service at 1-800-226-3545 ERR:NCP-AG-ADD-DOWN`,
                      ),
                    );
                  }
                });
              console.log(
                'JWT Token info',
                jwtDecode(response.signInUserSession.idToken.jwtToken),
              );
              //  }, 5000);
              setAuthTokens(session);
            } else {
              dispatch(loginActions.setLoginFailed(false));
              history.push('/login');
            }
          })
          .catch(err => {
            console.error(
              'actions.validateUserSession():Auth.userSession() err:',
              err,
            );
            // error occured during session validation, fire user is unauthenticated
            dispatch(loginActions.setLoginFailed(false));
            history.push('/');
            // history.push('/');
          });
        onSuccess();
        history.push('/home');
      })
      .catch(error => {
        console.log('login error in login method', error);

        if (
          error.code === 'UserNotConfirmedException' &&
          error.message === 'User is not confirmed.'
        ) {
          let data = {
            resend: true,
            email: user,
            error: `Your account isn't confirmed! 
              Please check your email to find the confirmation code.`,
          };
          history.push('/register', { data });
        } else if (
          error.code === 'NotAuthorizedException' &&
          error.message === 'User is disabled.'
        ) {
          dispatch(
            loginActions.setLoginError(
              false,
              `Your user account has been locked. Please contact 1800-226-3545 to unlock your account.`,
            ),
          );
        } else if (
          error.code === 'NotAuthorizedException' &&
          error.message !== 'Incorrect username or password.'
        ) {
          dispatch(
            loginActions.setLoginError(
              false,
              `Your user account has been locked because of too many failed
          attempts. Please contact 1800-226-3545 to unlock your account.`,
            ),
          );
        } else if (
          error.code === 'NotAuthorizedException' &&
          error.message === 'Incorrect username or password.'
        ) {
          dispatch(loginActions.setLoginError(false, error.message));
        } else {
          dispatch(loginActions.setLoginError(false, error.message));
        }
      });
  };
}

export function validateUserSession() {
  return dispatch => {
    dispatch(loginActions.setAgentRemoveInfoError());
    dispatch(loginActions.setLoginPending(true));
    Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
      .then(currentAuthUser => {
        console.log(
          'actions.validateUserSession():Auth.currentAuthenticatedUser() currentAuthUser:',
          currentAuthUser,
        );
        // grab the user session
        Auth.userSession(currentAuthUser)
          .then(authSession => {
            console.log(
              'actions.validateUserSession():Auth.userSession() session:',
              authSession.idToken.jwtToken,
            );
            if (authSession.isValid()) {
              dispatch(
                loginActions.setLoginSuccess(
                  false,
                  currentAuthUser,
                  getCurrentUser(currentAuthUser.attributes),
                  currentAuthUser.signInUserSession.idToken.jwtToken,
                ),
              );
              setAuthTokens(authSession);
            } else {
              dispatch(loginActions.setLoginFailed(false));
              localStorage.clear();
              history.push('/login');
            }
          })
          .catch(err => {
            console.error(
              'actions.validateUserSession():userSession() err:',
              err,
            );
            // error occured during session validation, fire user is unauthenticated
            dispatch(loginActions.setLoginFailed(false));
            history.push('/login');
          });
      })
      .catch(error => {
        console.log('login error in validate session', error);
        localStorage.clear();
        dispatch(loginActions.setLoginError(false, error.message));
      });
  };
}

export const setAuthTokens = session => {
  const expirationTime = new Date(new Date().getTime() + SIXTYMILLI * THOUSAND);
  localStorage.setItem('expirationTime', expirationTime);
  localStorage.setItem('access_token', session.idToken.jwtToken);
  history.push('/home');
};

export function refreshTokens() {
  return dispatch => {
    dispatch(loginActions.setLoginPending(true));

    Auth.currentSession()
      .then(currentAuthUser => {
        dispatch(
          loginActions.setLoginSuccess(
            false,
            currentAuthUser,
            getCurrentUser(currentAuthUser.attributes),
            currentAuthUser.signInUserSession.idToken.jwtToken,
          ),
        );
        const expirationTime = new Date(
          new Date().getTime() + SIXTYMILLI * THOUSAND,
        );
        localStorage.setItem('expirationTime', expirationTime);
        localStorage.setItem('access_token', currentAuthUser.idToken.jwtToken);
        console.log(currentAuthUser);
      })
      .catch(err => console.log(err));
  };
}

export function logout() {
  return dispatch => {
    dispatch(loginActions.setAgentRemoveInfoError());
    dispatch(loginActions.setLoginPending(true));
    Auth.signOut({ global: true })
      .then(response => {
        console.log('actions.logout():Auth.signOut() data:', response);
        dispatch(loginActions.signOutAction());
        localStorage.removeItem('access_token');
        localStorage.clear();
        history.push('/login');
      })
      .catch(error => {
        if (error.code === 'NotAuthorizedException') {
          dispatch(
            loginActions.setLoginError(
              false,
              `Your user account has been locked because of too many failed
          attempts. Please contact 1800-226-3545 to unlock your account.`,
            ),
          );
        }
        localStorage.clear();
        history.push('/login');
        console.log('logout  error', error);
        // dispatch(loginActions.setLoginError(false, error.message))
      });
  };
}

export const checkAuthTimeOut = expirationTime => dispatch => {
  return setTimeout(() => {
    dispatch(logout());
  }, expirationTime * THOUSAND);
};

export const getCurrentUser = response => {
  return {
    emailAddress: response['email'],
    firstName: response['custom:firstName'],
    lastName: response['custom:lastName'],
    companyName: response['custom:companyName'],
    street: response['custom:street'],
    streetline2: response['custom:streetLine2'],
    city: response['custom:city'],
    state: response['custom:state'],
    zipCode: response['custom:zipCode'],
    phoneNumber: response['custom:phoneNumber'],
    companyWebSite: response['custom:companyWebSite'],
  };
};
